import React from "react"

import Layout from "components/Layout"
import Breadcrumbs from "components/Breadcrumbs"
import PageHeader from "components/PageHeader"
import Popup from "components/Popup"

import { Content } from "page_components/investments"

import investments from "data/investments"
import offices_data from "data/offices_data"

const Apartments = ({ location }) => {
  const title = "Nowe mieszkania w Częstochowie"

  return (
    <Layout
      location={location}
      seo={{
        title: "Częstochowa - nowe mieszkania od dewelopera",
        description:
          "Mieszkania w Częstochowie od dewelopera Trust Investment. Zobacz nowe inwestycje, atrakcyjne lokalizacje i dostępne układy lokali.",
        hreflang: [
          {
            lang: "pl",
            href: "https://trustinvestment.pl/mieszkania/czestochowa/",
          },
          {
            lang: "en",
            href: "https://trustinvestment.pl/en/flats/czestochowa/",
          },
          {
            lang: "uk",
            href: "https://trustinvestment.pl/ua/kvartyry/chenstokhova/",
          },
          {
            lang: "x-default",
            href: "https://trustinvestment.pl/mieszkania/czestochowa/",
          },
        ],
      }}
      rmGlobalPopup
    >
      <Breadcrumbs
        title={title}
        parent={{ label: "Mieszkania", url: "/mieszkania" }}
      />
      <PageHeader title={title} />
      {investments
        ?.filter(item => item.city === "Częstochowa")
        .map((item, index) => (
          <Content
            key={index}
            city={item?.city}
            // sub_title="Inwestycja sprzedana"
            investments={item?.investments}
            office={offices_data?.find(office => office.city === "Częstochowa")}
            rmSubHeader
          />
        ))}
      <Popup type="czestochowa" />
    </Layout>
  )
}

export default Apartments
